<template>
  <div class="config-container">
    <div class="top-select-container">
      <div class="org-container">
        <p class="org-container-name">{{ schoolSelectName || '- -' }}</p>
        <img
          class="org-container-icon"
          src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202307/ddd303c5e801417d820d391216d4e848.png"
          alt="切换"
          @click="switchingSchoolDialogFlag = true"
        />
      </div>
      <div class="org-container" style="position: relative">
        <p class="org-container-name">教室编号</p>
        <a-select
          v-model="panoramaClassroomCode"
          style="width: 200px"
          @change="handleClassroomChange"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option :value="classroomCode" v-for="(classroomCode, index) in panoramaClassroomList" :key="index">
            {{ classroomCode }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div class="catalog-config">
      <div class="useing-catalog">
        <div class="catalog-title">大数据页面目录</div>
        <div class="catalog-content">
          <draggable
            class="list-group"
            tag="ul"
            v-model="useingPageList"
            v-bind="dragOptions"
            :move="onMove"
            @start="handlerStart"
            @end="handlerEnd"
            :group="{ name: 'draggableBox', pull: true, put: true }"
          >
            <!-- <transition-group type="transition" :name="'flip-list'"> -->
            <template v-if="useingPageList && useingPageList.length">
              <ScreenCard
                v-for="item in useingPageList"
                :key="item.id"
                :screenInfo="item"
                @updateScreenPageList="getAdminScreenPage"
              />
            </template>
            <template v-else>
              <div class="draggable-container">可拖拽至此区域</div>
            </template>
            <!-- </transition-group> -->
          </draggable>
        </div>
      </div>
      <div class="no-useing-catalog">
        <div class="catalog-title">未使用的大屏</div>
        <div class="catalog-content">
          <div class="no-useing-list">
            <draggable
              class="list-group"
              tag="ul"
              v-model="noUseingPageList"
              v-bind="dragOptions"
              :move="onMove"
              @start="handlerStart"
              @end="handlerEnd"
              :group="{ name: 'draggableBox', pull: true, put: true }"
            >
              <!-- <transition-group type="transition" :name="'flip-list'"> -->
              <template v-if="noUseingPageList && noUseingPageList.length">
                <ScreenCard
                  v-for="item in noUseingPageList"
                  :key="item.id"
                  :screenInfo="item"
                  @updateScreenPageList="getAdminScreenPage"
                />
              </template>
              <template v-else>
                <div class="draggable-container">可拖拽至此区域</div>
              </template>
              <!-- </transition-group> -->
            </draggable>
          </div>
          <div class="empty-card" @click="addPage">
            <div class="add-screen-card">
              <a-icon type="plus-circle" :style="{ fontSize: '40px', color: '#ccc' }" />
              <div class="tip-text">添加一页自定义大屏</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddDialog
      :showAddDialog.sync="showAddDialog"
      :currentScreenInfo="emptyScreenInfo"
      :showType="showType"
      :panoramaClassroomCode="panoramaClassroomCode"
      @updateScreenlist="getAdminScreenPage"
    />

    <SwitchSchool
      :switchingSchoolDialogFlag="switchingSchoolDialogFlag"
      @handleSwitchingSchoolDialogClose="handleSwitchingSchoolDialogClose"
    />
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import ScreenCard from './components/screenCard.vue'
import AddDialog from './components/addOrEditDialog.vue'
import store from '@/store'
import SwitchSchool from '@/components/switchingSchool'
import { mapMutations, mapGetters, mapActions } from 'vuex'
export default {
  name: 'dragging',
  components: {
    draggable,
    ScreenCard,
    AddDialog,
    SwitchSchool
  },
  data() {
    return {
      flagDraggable: true,
      isDragging: false,
      delayedDragging: false,
      allScreenPageList: [],
      useingPageList: [],
      noUseingPageList: [],
      showType: 0,
      showAddDialog: false,
      emptyScreenInfo: {
        pageName: '',
        pageType: 2,
        sourceName: '',
        pageDescribe: '',
        sourceType: 1, // 1 图片 2 视频
        sort: 0
      },
      switchingSchoolDialogFlag: false,
      schoolCode: '',
      panoramaClassroomList: [],
      panoramaClassroomCode: ''
    }
  },
  computed: {
    ...mapGetters('switchingSchool', ['schoolSelect', 'schoolSelectName']),
    dragOptions() {
      return {
        animation: 0,
        disabled: !this.flagDraggable,
        ghostClass: 'ghostClass'
      }
    }
  },
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true
        return
      }
      this.$nextTick(() => {
        this.delayedDragging = false
      })
    },
    schoolSelect: {
      handler: async function (newVal) {
        if (!newVal) return
        this.schoolCode = newVal
        await this.getPanoramaClassroomList()
        await this.getAdminScreenPage()
      },
      immediate: true
    }
  },
  created() {
    // this.getAdminScreenPage()
  },
  methods: {
    // 切换教室编号
    handleClassroomChange(value) {
      this.panoramaClassroomCode = value
      this.getAdminScreenPage()
    },
    // 获取全景教室数据列表
    async getPanoramaClassroomList() {
      const res = await this.$http.getPanoramaClassroomCodeList({
        schoolCode: String(this.schoolCode)
      })
      if (res.code === 200 && res.rt && res.rt.length) {
        this.panoramaClassroomList = res.rt
        this.panoramaClassroomCode = this.panoramaClassroomList[0]
      } else {
        this.panoramaClassroomList = []
        this.panoramaClassroomCode = ''
      }
    },
    handleSwitchingSchoolDialogClose() {
      this.switchingSchoolDialogFlag = false
    },
    async getAdminScreenPage() {
      if (!this.panoramaClassroomCode) return
      const res = await this.$http.getAdminScreenPage({
        panoramaClassroomCode: this.panoramaClassroomCode
      })
      if (res.code == 200) {
        this.allScreenPageList = res.rt || []
        this.useingPageList = this.allScreenPageList.filter((item) => item.activated)
        this.noUseingPageList = this.allScreenPageList.filter((item) => !item.activated)
      }
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element
      const draggedElement = draggedContext.element
      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
    },
    handlerStart() {
      this.isDragging = true
    },
    handlerEnd() {
      this.isDragging = false
      this.useingPageList.map((item, index) => {
        item.sort = index + 1
        item.activated = true
      })
      this.noUseingPageList.map((item, index) => {
        item.sort = index + 1
        item.activated = false
      })
      let newList = [...this.useingPageList, ...this.noUseingPageList]
      console.log(newList)
      this.batchUpdateList(newList)
    },
    addPage() {
      this.showType = 1
      this.showAddDialog = true
    },
    async batchUpdateList(list) {
      let formDataParams = new FormData()
      formDataParams.append('pages', JSON.stringify(list))
      const res = await this.$http.batchUpdateScreen(formDataParams, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: store.getters['userInfo/token']
        }
      })
      if (res.code == 200) {
        this.getAdminScreenPage()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.top-select-container {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  font-size: 14px;
}
.org-container {
  display: flex;
  align-items: center;
  margin-right: 30px;
  .org-container-name {
    font-size: 14px;
    color: #1e2228;
    margin-right: 8px;
  }
  .org-container-icon {
    width: 16px;
    height: 16px;
    display: block;
    cursor: pointer;
    user-select: none;
  }
}
.catalog-config {
  width: 100%;
  height: calc(100vh - 56px - 40px);
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 16px;
  .useing-catalog,
  .no-useing-catalog {
    width: 100%;
    height: 100%;
    padding: 16px;
    background-color: #fff;
  }
}
.catalog-title {
  height: 14px;
  padding-left: 8px;
  font-size: 14px;
  line-height: 14px;
  color: #1e2228;
  position: relative;
  text-align: left;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 2px;
    height: 12px;
    background: #5f60d3;
  }
}
.useing-catalog {
  .catalog-content {
    margin-top: 16px;
    width: 100%;
    // 头部 56 主体上下Padding共40 列表上下padding32 列表标题14 列表content margin-top 16
    height: calc(100vh - 56px - 40px - 32px - 16px - 14px);
    padding: 16px;
    background-color: #f5f8fa;
    display: flex;
    justify-content: center;
    overflow-y: auto;
  }
}
.no-useing-catalog {
  align-items: center;
  .catalog-content {
    margin-top: 16px;
    width: 100%;
    height: calc(100vh - 56px - 40px - 32px - 16px - 14px);
    padding: 16px;
    background-color: #f5f8fa;
    display: flex;
    flex-direction: column;
  }
  .no-useing-list {
    // flex: 1;
    width: 100%;
    height: auto;
    max-height: calc(100% - 116px - 16px);
    display: flex;
    justify-content: center;
    overflow-y: auto;
  }
  .empty-card {
    margin-top: 16px;
    width: 100%;
    height: 116px;
    display: flex;
    justify-content: center;
  }
  .add-screen-card {
    width: 400px;
    height: 116px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    cursor: pointer;
    .tip-text {
      margin-left: 16px;
      color: #9ca5b1;
    }
  }
}
.draggable-container {
  width: 100%;
  height: 100px;
  border: 1px dashed #ddd;
  line-height: 100px;
  color: #ddd;
}

.ghostClass {
  background: #c8ebfb !important;
  opacity: 0.5 !important;
}
.list-group {
  width: 400px;
  min-height: 100px;
}

// ::-webkit-scrollbar{
//   width: 8px;
// //   background-color: transparent;
// }
// ::-webkit-scrollbar-thumb{
// //   background-color: transparent;
//   border-radius: 8px;
// }
</style>
